module.exports = __webpack_public_path__ + "static/media/React.1d1d8dab.png";